import { IPaginationMeta } from "../types/ownerDashboard.types";

export function normalizePagination(value: unknown): IPaginationMeta | undefined {
  if (!value || typeof value !== "object") {
    return undefined;
  }

  const record = value as Record<string, unknown>;
  const currentPage = Number(record.current_page);
  const perPage = Number(record.per_page);
  const total = Number(record.total);
  const lastPage = Number(record.last_page);

  if (
    !Number.isFinite(currentPage) ||
    !Number.isFinite(perPage) ||
    !Number.isFinite(total) ||
    !Number.isFinite(lastPage)
  ) {
    return undefined;
  }

  return {
    current_page: currentPage,
    per_page: perPage,
    total,
    last_page: lastPage,
  };
}
